import { render, staticRenderFns } from "./GatewayNumber.vue?vue&type=template&id=2592d956&scoped=true&"
import script from "./GatewayNumber.vue?vue&type=script&lang=js&"
export * from "./GatewayNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2592d956",
  null
  
)

export default component.exports